


















































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Api from "@/api";
import moment from "moment";
import { AxiosResponse } from "axios";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import Table from "@/components/Common/Table.vue";

import swal from "sweetalert";
import "vue-slider-component/theme/default.css";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";
import {
  IInventoryProductBooking,
  IFacility,
  ITableParams,
  IPagination,
  ICustomerType,
  BookingStatus,
  ICustomerGroup,
  IInventoryProduct
} from "@/interface";

interface IFilter {
  starts_at: Date;
  ends_at: Date | null;
  customer_type_id: number | null;
  customer_group_id: number | null;
  status: Array<BookingStatus>;
  inventory_product_id: number | null;
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    DatePicker,
    Multiselect,
    AlertBox
  }
})
export default class BookingInventoryProducts extends Vue {
  public loading = false;
  public updating = false;
  private facilities: Array<IFacility> = [];
  private selectedFacilityId = "";
  private showSearchModal = false;
  private componentKey = 0;
  private bookings: Array<IInventoryProductBooking> = [];
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    search: ""
  };
  private dateFormat = "DD.MM.YYYY";
  private customer_typeOptions: Array<ICustomerType> = [
    { name: "Privat", id: 1 },
    { name: "Firma", id: 2 },
    { name: "Verein", id: 3 },
    { name: "Kindergarten", id: 4 },
    { name: "Schule", id: 5 },
    { name: "Hobby", id: 6 }
  ];
  private statuses: Array<BookingStatus> = [];
  private customer_groups: Array<ICustomerGroup> = [];
  private filter: IFilter = {
    starts_at: new Date(),
    ends_at: null,
    customer_type_id: null,
    customer_group_id: null,
    status: [],
    inventory_product_id: null
  };
  private products: Array<IInventoryProduct> | null = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      if (vm.$route.query.inventory_product_deleted === "true") {
        swal(
          "Success!",
          "The inventory product booking was canceled.",
          "success"
        ).then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getBookings(() => {
        //
      });
      vm.getGroups();
      vm.getProducts();
      vm.getFacilities();
      vm.getBookingStatuses();
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.inventory_product_deleted === "true") {
      swal(
        "Success!",
        "The inventory product booking was canceled.",
        "success"
      ).then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getBookings(() => {
      //
    });
    this.getGroups();
    this.getProducts();
    this.getFacilities();
    this.getBookingStatuses();
    next();
  }

  private openModal(): void {
    this.showSearchModal = true;
  }

  private closeModal(): void {
    this.showSearchModal = false;
    this.filter = {
      starts_at: new Date(),
      ends_at: null,
      customer_type_id: null,
      customer_group_id: null,
      status: [],
      inventory_product_id: null
    };
  }

  private handleSearch(): void {
    this.getBookings();
    this.showSearchModal = false;
  }

  private getBookings(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.bookings = [];
    // const filter = {
    //   ...this.filter,
    //   starts_at: this.convertDate(this.filter.starts_at),
    //   ends_at: this.filter.ends_at
    //     ? this.convertDate(this.filter.ends_at)
    //     : "",
    //   status: this.filter.status
    // };
    const endpoint: string = this.$partnerEndpoint(
      "bookings/inventory-products"
    );

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          search: this.fetchParams.search,
          per_page: this.fetchParams.per_page
        }
      })
      .then((response: AxiosResponse) => {
        this.bookings = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private cancelBooking(inventoryProductBooking: {
    booking: IInventoryProductBooking;
  }): void {
    if (
      this.loading ||
      this.updating ||
      inventoryProductBooking.booking.id == null
    ) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The inventory product booking will be cancelled",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "bookings/" + inventoryProductBooking.booking.id
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "BookingInventoryProduct",
                query: { inventory_product_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal(
                    "Success!",
                    "The inventory product booking was deleted.",
                    "success"
                  );
                  this.getBookings(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete external venues.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getGroups(): void {
    const endpoint: string = this.$partnerEndpoint("groups");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.customer_groups = response.data.data;
      });
  }

  private getProducts(): void {
    const endpoint: string = this.$partnerEndpoint("inventory-products");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.products = response.data.data;
      });
  }

  private getFacilities(): void {
    const endpoint: string = this.$partnerEndpoint("facilities/simplified");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.facilities = response.data.data;
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getBookingStatuses(): void {
    const endpoint: string = this.$partnerEndpoint("bookings/statuses");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.statuses = response.data.data;
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  private generatePeriod(row: IInventoryProductBooking): string {
    const { starts_at, ends_at } = row;
    const start = moment(starts_at).format("MM/DD/YYYY");
    const end = moment(ends_at).format("MM/DD/YYYY");
    if (start === end) {
      const startTime = moment(starts_at).format("hh:mm");
      const endTime = moment(ends_at).format("hh:mm");
      return `${start} ${startTime} - ${endTime}`;
    }

    return `${start} - ${end}`;
  }
}
